import { render, staticRenderFns } from "./MaterialWeightsGraph.vue?vue&type=template&id=eb517ed8&scoped=true&"
import script from "./MaterialWeightsGraph.vue?vue&type=script&lang=js&"
export * from "./MaterialWeightsGraph.vue?vue&type=script&lang=js&"
import style0 from "./MaterialWeightsGraph.vue?vue&type=style&index=0&id=eb517ed8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb517ed8",
  null
  
)

export default component.exports